import styled from "styled-components"
import Markdown from "@irati/ui/src/Markdown/index"
import padding from "@irati/ui/src/global/padding"
import {minWidthMedia} from "@irati/ui/src/global/media"
import widths from "../../../ui/widths"

export const SpacedMarkdown = styled(Markdown)`
  margin-bottom: ${padding.small};

  ${minWidthMedia.tablet`
    max-width: ${widths.medium};
  `}
`
